<template>
  <div class="container-fluid px-0 d-flex gap-15" ref="vehicleTab" v-if="!loadingState">
    <div class="row gx-10 flex-grow-1" style="width: 1005px;">
      <div class="col-12">
        <div class="d-flex align-items-center gap-15 mb-5 wp-100">
          <div class="system-block wp-100 pb-10" >
            <p class="fw-bolder fsc-12 mb-15">
              ОСАГО
            </p>
            <div class="">
              <div class="d-flex mb-10 gap-10">
                <div ref="vehicle_osago__policy">
                  <BaseInputNew placeholder="" :width="'220'" input-name="vehicle_osago__policy" @input="updateValue"
                    :horizontalTitle="true" :value="dataForModal.vehicle_osago__policy"
                    :name-sign="dataLang['vehicle_modal_security_osago_policy']">
                  </BaseInputNew>
                </div>
                <div class="d-flex gap-5 justify-content-between align-items-center">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_osago_policy_from'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="dataTimeSelect.vehicle_osago__policy_from" :clearable="false" type="date"
                      class="fsc-11 idiots-class-for-input-date" lang="ru" id="vehicle_osago__policy_from"
                      style="width: 110px" value-type="YYYY-MM-DD" :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(
                            date,
                            'vehicle_osago__policy_from',
                            {},
                            true
                          )
                      "></BaseDatePicker>
                  </div>
                </div>
                <div class="d-flex gap-5 justify-content-between align-items-center" ref="vehicle_osago__policy_to">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_osago_policy_to'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="dataTimeSelect.vehicle_osago__policy_to" :clearable="false" type="date"
                      class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 110px" value-type="YYYY-MM-DD"
                      :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(date, 'vehicle_osago__policy_to', {}, true)
                      "></BaseDatePicker>
                  </div>
                </div>
                <div ref="vehicle_osago__cost">
                  <BaseInputNew placeholder="" :width="'255'" input-name="vehicle_osago__cost" @input="updateValue"
                    :horizontalTitle="true" :value="dataForModal.vehicle_osago__cost" :name-sign="dataLang['vehicle_modal_security_osago_policy_cost']
                      ">
                  </BaseInputNew>
                </div>
              </div>
              <div class="d-flex mb-10 gap-10">
                <div ref="vehicle_osago__company_name" class="wp-100">
                  <BaseInputNew placeholder="" :width="'689'" input-name="vehicle_osago__company_name"
                    @input="updateValue" :horizontalTitle="true" :value="dataForModal.vehicle_osago__company_name"
                    :name-sign="dataLang[
                      'vehicle_modal_security_osago_policy_company_name'
                      ]
                      ">
                  </BaseInputNew>
                </div>
                <div ref="vehicle_osago__company_phone">
                  <BaseInputNew placeholder="" :width="'140'" input-name="vehicle_osago__company_phone"
                    @input="updateValue" :horizontalTitle="true" :value="dataForModal.vehicle_osago__company_phone"
                    inputRef="vehicle_osago__company_phone" inputMask="+{7}(000)000-00-00" :name-sign="dataLang[
                      'vehicle_modal_security_osago_policy_company_phone'
                      ]
                      " maxLength="16">
                  </BaseInputNew>
                </div>
              </div>
              <div class="">
                <span class="text-muted fsc-12">
                  {{ dataLang['vehicle_modal_security_osago_file'] }}
                </span>
                <div class="d-flex align-items-center gap-10 mt-10">
                  <span class="fsc-12" v-if="remoteAndAddedFileOsago">
                    Загружен
                  </span>
                  <a class="fsc-12 text-decoration-underline" :href="remoteAndAddedFileOsago" target="_blank"
                    v-if="remoteAndAddedFileOsago">
                    {{ remoteAndAddedFileOsago?.split('/')?.at(-1) }}
                  </a>
                  <div class="base-button base-button--action py-5 fsc-11 gap-10" v-if="remoteAndAddedFileOsago"
                    @click="() => clearFile('osago')">
                    <img :src="require(`@/assets/icons/crist.svg`)" width="13.5" height="13.5" />
                    <span class="fsc-14">Удалить файл</span>
                  </div>
                  <span class="fsc-12" v-if="remoteAndAddedFileOsago">или</span>
                  <label class="base-button base-button--action fsc-11 py-5 gap-10">
                    <img :src="require(`@/assets/icons/upload.svg`)" width="12" height="12.8" />
                    <span class="fsc-14"> Добавить файл</span>
                    <input type="file" @change="(e) => uploadFile(e, 'osago')" accept="image/*,.pdf" class="d-none" />
                  </label>
                  <span class="text-muted fsc-12" v-if="!remoteAndAddedFileOsago">
                    Файл не выбран
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center gap-15 mb-5 wp-100">
          <div class="system-block wp-100 pb-10">
            <p class="fw-bolder fsc-12 mb-15">
              КАСКО <span class="fw-normal">(если полиса нет - ничего не заполняйте)</span>
            </p>
            <div class="">
              <div class="d-flex mb-10 gap-10">
                <div ref="vehicle_kasko__policy">
                  <BaseInputNew placeholder="" :width="'220'" input-name="vehicle_kasko__policy" @input="updateValue"
                    :horizontalTitle="true" :value="dataForModal.vehicle_kasko__policy"
                    :name-sign="dataLang['vehicle_modal_security_osago_policy']">
                  </BaseInputNew>
                </div>
                <div class="d-flex gap-5 justify-content-between align-items-center">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_osago_policy_from'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="dataTimeSelect.vehicle_kasko__policy_from" :clearable="false" type="date"
                      class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 110px" value-type="YYYY-MM-DD"
                      :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(
                            date,
                            'vehicle_kasko__policy_from',
                            {},
                            true
                          )
                      "></BaseDatePicker>
                  </div>
                </div>
                <div class="d-flex gap-5 justify-content-between align-items-center" ref="vehicle_kasko__policy_to">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_osago_policy_to'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="dataTimeSelect.vehicle_kasko__policy_to" :clearable="false" type="date"
                      class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 110px" value-type="YYYY-MM-DD"
                      :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(date, 'vehicle_kasko__policy_to', {}, true)
                      "></BaseDatePicker>
                  </div>
                </div>
                <div ref="vehicle_kasko__cost">
                  <BaseInputNew placeholder="" :width="'255'" input-name="vehicle_kasko__cost" @input="updateValue"
                    :horizontalTitle="true" :value="dataForModal.vehicle_kasko__cost"
                    :name-sign="dataLang['vehicle_modal_security_kasko_cost']">
                  </BaseInputNew>
                </div>
              </div>
              <div class="d-flex gap-10">
                <div ref="vehicle_kasko__company_name" class="wp-100">
                  <BaseInputNew placeholder="" :width="'689'" input-name="vehicle_kasko__company_name"
                    @input="updateValue" :horizontalTitle="true" :value="dataForModal.vehicle_kasko__company_name"
                    :name-sign="dataLang['vehicle_modal_security_kasko_company_name']
                      ">
                  </BaseInputNew>
                </div>
                <div ref="vehicle_kasko__company_phone">
                  <BaseInputNew placeholder="" :width="'140'" input-name="vehicle_kasko__company_phone"
                    @input="updateValue" :horizontalTitle="true" :value="dataForModal.vehicle_kasko__company_phone"
                    inputRef="vehicle_kasko__company_phone" inputMask="+{7}(000)000-00-00" maxLength="16" :name-sign="dataLang[
                      'vehicle_modal_security_osago_policy_company_phone'
                      ]
                      ">
                  </BaseInputNew>
                </div>
              </div>
              <div class="">
                <span class="text-muted fsc-12">
                  {{ dataLang['register_objects_car_text_53'] }}
                </span>
                <div class="d-flex align-items-center gap-10">
                  <span class="fsc-12" v-if="remoteAndAddedFileKasko">
                    Загружен
                  </span>
                  <a class="fsc-12 text-decoration-underline" :href="remoteAndAddedFileKasko" target="_blank"
                    v-if="remoteAndAddedFileKasko">
                    {{ remoteAndAddedFileKasko?.split('/')?.at(-1) }}
                  </a>
                  <div class="base-button base-button--action py-5 fsc-11 gap-10" v-if="remoteAndAddedFileKasko"
                    @click="() => clearFile('kasko')">
                    <img :src="require(`@/assets/icons/crist.svg`)" width="13.5" height="13.5" />
                    <span class="fsc-14">Удалить файл</span>
                  </div>
                  <span class="fsc-12" v-if="remoteAndAddedFileKasko">или</span>
                  <label class="base-button base-button--action fsc-11 py-5 gap-10">
                    <img :src="require(`@/assets/icons/upload.svg`)" width="12" height="12.8" />
                    <span class="fsc-14"> Добавить файл</span>
                    <input type="file" @change="(e) => uploadFile(e, 'kasko')" accept="image/*,.pdf" class="d-none" />
                  </label>
                  <span class="text-muted fsc-12" v-if="!remoteAndAddedFileKasko">
                    Файл не выбран
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center gap-5 mb-5 wp-100">
          <div class="d-flex align-items-center flex-grow-1 wp-100" style="max-width: 1034px">
            <div class="d-flex align-items-center gap-5 wp-100" style="max-width: 100%">
              <div v-if="dataForModal.vehicles__is_active_fines"
                   class="text-center d-flex flex-column justify-content-center border rounded-5 border-disabled gap-0"
                   style="height: 78px; width: 510px">
                <p class="fs-8 fw-bold mb-0">Сириус контролирует штрафы и платные проезды этого объекта.</p>
                <p class="fs-9 mb-0">Управление: 719 раздел</p>
              </div>
              <div v-else class="text-center d-flex flex-column justify-content-center border rounded-5 border-disabled gap-0"
                   style="height: 78px; width: 510px; background-color: #FF3A20">
                <p style="color: white" class="fs-8 fw-bold mb-0">Штрафы и платные дороги этого объекта сейчас не контролируются!</p>
                <p style="color: white" class="fs-9 mb-0">Управление: 719 раздел</p>
              </div>

              <!-- "rows": [
            {
                "vehicle_gps__company_id": 2,
                "vehicle_gps__gps_operator": null,
                "vehicle_gps__id": 33,
                "vehicle_gps__phone": "+7(000)000-00-00",
                "vehicle_gps__tracker_id": null,

                "vehicle_gps__vehicle_id": 33
            }
        ] -->
              <div>
                <div
                  class="bg-danger text-white d-flex text-center align-items-center justify-content-center rounded-5 flex-column"
                  v-if="!dataForModal?.gps__tracker_id" style="width: 169px; height: 78px">
                  <span class="fw-bold fsc-12">{{
                    dataLang['register_objects_car_text_5']
                    }}</span>
                  <span class="fsc-11">{{
                    dataLang['register_objects_car_text_6']
                    }}</span>
                </div>
                <div class="d-flex flex-column py-10 px-15 border rounded-5 border-disabled gap-0"
                  v-if="dataForModal?.gps__tracker_id" style="width: 169px; height: 78px; line-height: 14px">
                  <span class="fw-bold fsc-12">{{
                    dataLang['register_objects_car_text_5']
                    }}</span>
                  <span class="fsc-11">{{
                    dataForModal?.gps__tracker_id
                    }}</span>
                  <span class="fsc-11">{{ dataForModal?.gps__sim_phone }}</span>
                  <span class="fsc-11">{{
                    dataForModal?.gps__sim_operator
                    }}</span>
                </div>
              </div>
              <div class="d-flex py-10 px-15 border rounded-5 border-disabled gap-10 flex-column flex-grow-1"
                style="height: 78px; min-width: 335px">
                <div>
                  <BaseCheckboxV2 placeholder="" input-name="vehicles__is_active_can"
                    v-model="dataForModal.vehicles__is_active_can" @oncheckeds="updateValue"><span class="text-dark">
                      Автообновление пробега по CAN (1 раз в сутки)
                    </span>
                  </BaseCheckboxV2>
                </div>
                <div>
                  <BaseCheckboxV2 placeholder="" input-name="vehicles__is_active_can_motohour"
                    v-model="dataForModal.vehicles__is_active_can_motohour" @oncheckeds="updateValue"><span class="text-dark">
                      Автообновление МЧ по CAN (1 раз в сутки)
                    </span>
                  </BaseCheckboxV2>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-12">
        <div class="d-flex align-items-center gap-5 wp-100">
          <div class="system-block wp-100 flex-grow-1" style="max-width: 1034px">
            <p class="fw-bolder fsc-12 mb-10">
              Поисковые маяки <span class="fw-normal">(маяки с независимым питанием - последний шанс найти объект при угоне)</span>
            </p>
            <div class="gap-25 d-flex">
              <div class="">
                <div ref="vehicle_lighthouses__sim" class="mb-10">
                  <BaseInputNew placeholder="" :width="'220'" input-name="vehicle_lighthouses__sim" @input="updateValue"
                    :horizontalTitle="true" :value="lighhouseList[0].vehicle_lighthouses__sim"
                    :additionalParams="lighhouseList[0]" inputRef="vehicle_kasko__company_phone1"
                    inputMask="+{7}(000)000-00-00" maxLength="16" :name-sign="dataLang['vehicle_modal_security_lighthouses_sim']
                      ">
                  </BaseInputNew>
                </div>
                <div ref="vehicle_lighthouses__sim" class="mb-10">
                  <BaseInputNew placeholder="" :width="'220'" input-name="vehicle_lighthouses__sim" @input="updateValue"
                    :horizontalTitle="true" :value="lighhouseList[1].vehicle_lighthouses__sim"
                    :additionalParams="lighhouseList[1]" inputRef="vehicle_kasko__company_phone2"
                    inputMask="+{7}(000)000-00-00" maxLength="16" :name-sign="dataLang['vehicle_modal_security_lighthouses_sim']
                      ">
                  </BaseInputNew>
                </div>
                <div ref="vehicle_lighthouses__sim">
                  <BaseInputNew placeholder="" :width="'220'" input-name="vehicle_lighthouses__sim" @input="updateValue"
                    :horizontalTitle="true" :value="lighhouseList[2].vehicle_lighthouses__sim"
                    :additionalParams="lighhouseList[2]" inputRef="vehicle_kasko__company_phone3"
                    inputMask="+{7}(000)000-00-00" maxLength="16" :name-sign="dataLang['vehicle_modal_security_lighthouses_sim']
                      ">
                  </BaseInputNew>
                </div>
              </div>
              <div class="">
                <div class="d-flex gap-5 justify-content-between align-items-center mb-10">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_lighthouses_date'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="lighhouseList[0].vehicle_lighthouses__added_at" :clearable="false"
                      type="date" class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 112px"
                      value-type="format" :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(
                            date,
                            'vehicle_lighthouses__added_at',
                            lighhouseList[0]
                          )
                      "></BaseDatePicker>
                  </div>
                </div>
                <div class="d-flex gap-5 justify-content-between align-items-center mb-10">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_lighthouses_date'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="lighhouseList[1].vehicle_lighthouses__added_at" :clearable="false"
                      type="date" class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 112px"
                      value-type="format" :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(
                            date,
                            'vehicle_lighthouses__added_at',
                            lighhouseList[1]
                          )
                      "></BaseDatePicker>
                  </div>
                </div>
                <div class="d-flex gap-5 justify-content-between align-items-center">
                  <span class="text-muted fsc-12">
                    {{ dataLang['vehicle_modal_security_lighthouses_date'] }}
                  </span>
                  <div>
                    <BaseDatePicker v-model="lighhouseList[2].vehicle_lighthouses__added_at" :clearable="false"
                      type="date" class="fsc-11 idiots-class-for-input-date" lang="ru" style="width: 112px"
                      value-type="format" :format="userSetting.company__tempalte_date" @change="
                        (date) =>
                          changeDate(
                            date,
                            'vehicle_lighthouses__added_at',
                            lighhouseList[2]
                          )
                      "></BaseDatePicker>
                  </div>
                </div>
              </div>
              <div class="">
                <div ref="vehicle_lighthouses__change_after_days" class="mb-10">
                  <BaseInputNew placeholder="" :width="'194'" input-name="vehicle_lighthouses__change_after_days"
                    @input="updateValue" :horizontalTitle="true" :value="lighhouseList[0].vehicle_lighthouses__change_after_days
                      " :additionalParams="lighhouseList[0]" :name-sign="dataLang['vehicle_modal_security_lighthouses_days']
                      ">
                  </BaseInputNew>
                </div>
                <div ref="vehicle_lighthouses__change_after_days" class="mb-10">
                  <BaseInputNew placeholder="" :width="'194'" input-name="vehicle_lighthouses__change_after_days"
                    @input="updateValue" :horizontalTitle="true" :value="lighhouseList[1].vehicle_lighthouses__change_after_days
                      " :additionalParams="lighhouseList[1]" :name-sign="dataLang['vehicle_modal_security_lighthouses_days']
                      ">
                  </BaseInputNew>
                </div>
                <div ref="vehicle_lighthouses__change_after_days">
                  <BaseInputNew placeholder="" :width="'194'" input-name="vehicle_lighthouses__change_after_days"
                    @input="updateValue" :horizontalTitle="true" :value="lighhouseList[2].vehicle_lighthouses__change_after_days
                      " :additionalParams="lighhouseList[2]" :name-sign="dataLang['vehicle_modal_security_lighthouses_days']
                      ">
                  </BaseInputNew>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-between">
      <div @click="$modal.show('orderSendModal', { productId: 13, productName: 'Полис ОСАГО', objectId: currentOpenedId, ownerId: dataForModal?.vehicles__owner_id })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;" v-html="dataLang['vehicle_modal_security_btns_get_osago']">
          </div>
      <div @click="$modal.show('orderSendModal', { productId: 14, productName: 'Полис КАСКО', objectId: currentOpenedId, ownerId: dataForModal?.vehicles__owner_id })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;" v-html="dataLang['vehicle_modal_security_btns_get_kasko']"></div>
      <div @click="$modal.show('orderSendModal', { productId: 15, productName: 'GPS трекеры', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;" v-html="dataLang['vehicle_modal_security_btns_get_gps']"></div>
      <div @click="$modal.show('orderSendModal', { productId: 16, productName: 'GPS маяки', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;" v-html="dataLang['vehicle_modal_security_btns_get_lighthouse']"></div>

      <div @click="$modal.show('orderSendModal', { productId: 17, productName: 'Установка GPS', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;">
            Установка GPS
          </div>
      <div @click="$modal.show('orderSendModal', { productId: 24, productName: 'Сотрудник на авто', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;">
            Выезд к объекту
          </div>
      <div @click="$modal.show('orderSendModal', { productId: 8, productName: 'Эвакуация легковых авто', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;">
            Вызвать Эвакуатор
          </div>
      <div @click="$modal.show('orderSendModal', { productId: 12, productName: 'Водитель', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;">
            Водитель-перегонщик
          </div>
      <div @click="$modal.show('orderSendModal', { productId: 19, productName: 'Юрист', objectId: currentOpenedId })"
            class="fsc-14 cursor-pointer text-center base-button--action text-white px-10 flex-grow-0"
            style=" width: 200px; background-color: #023F8F; padding-block: 16px; text-transform: uppercase; border-radius: 5px;">
            Юр. консультация
          </div>
    </div>
    <gallery v-if="loadGallery" :images="images" :index="index" @close="index = null"></gallery>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import ObjectsService from '@/api/ObjectsService'
import StorageFileService from '@/api/StorageFileService'

import EventBus from '@/event-bus'
import VueGallery from 'vue-gallery'
import GeneralService from '@/api/GeneralService'
export default {
  components: {
    gallery: VueGallery
  },

  props: {
    modeOpenModal: {
      type: String,
      default: 'create'
    },

    currentOpenedId: {
      type: Number
    }
  },
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      remoteAndAddedFileOsago: null,
      remoteAndAddedFileKasko: null,
      loadingState: true,
      settingGlobalData: {},
      images: [],
      index: null,
      loadGallery: false,
      dataTimeSelect: {
        vehicle_kasko__policy_to: '',
        vehicle_kasko__policy_from: '',
        vehicle_osago__policy_to: '',
        vehicle_osago__policy_from: ''
      },
      lighhouseList: [],
      lighhouseListForSend: []
    }
  },
  methods: {
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      if (Object.keys(this.updatedValues).length) {
        ObjectsService.update(this.currentOpenedId, {
          ...this.updatedValues,
          ...{
            lighthouses: this.lighhouseListForSend,
            vehicle_gps__phone: '+7(000)000-00-00'
          }
        })
          .then((data) => {
            EventBus.$emit('contentLoaded')
            EventBus.$emit('updateContentData')
            this.$toast.success(data.data.message)
            callback(true, nameTab, oldTab, newTab, flagIsClose)
          })
          .catch((error) => {
            this.$toast.error(error.response.data.message, { duration: 5000 })
            callback(false, nameTab, oldTab, newTab)
          })
      } else {
        callback(true, '', oldTab, newTab, flagIsClose)
      }
    },

    uploadFile(e, type) {
      this.$emit('loadingModal', true)
      StorageFileService.upload({
        file: e.target.files[0],
        type: 'default'
      })
        .then((data) => {
          this.$toast.success(data.data.message)
          if (type == 'osago') {
            this.remoteAndAddedFileOsago = data.data.data.url
            this.updatedValues.vehicle_osago__file = data.data.data.id
          } else {
            this.remoteAndAddedFileKasko = data.data.data.url
            this.updatedValues.vehicle_kasko__file = data.data.data.id
          }

        })
        .catch((error) => {
          this.$toast.error(error.response.data.message, { duration: 5000 })
        })
      this.$emit('loadingModal', false)
      // StorageFileService.upload()
    },
    clearFile(type) {
      if (type == 'osago') {
        this.remoteAndAddedFileOsago = null
        this.updatedValues.vehicle_osago__file = ''
      } else {
        this.remoteAndAddedFileKasko = null
        this.updatedValues.vehicle_kasko__file = ''
      }

    },

    changeDate(date, nameField, additionalParams, isSimpleInputDate) {
      const normalizedDate = this.normalizeDateForApi(date)
      this.updatedValues[nameField] = normalizedDate

      if (nameField == 'vehicle_lighthouses__added_at') {
        const lighthouseItem = this.lighhouseListForSend.find(
          (x) => x.id == additionalParams.vehicle_lighthouses__id
        )

        if (lighthouseItem) {
          lighthouseItem[nameField] = normalizedDate
        }
      }
    },

    normalizeDateForApi(date) {
      if (!date) {
        return null
      }

      // Date picker can return values in different string formats depending on settings.
      const formats = [
        this.userSetting.company__tempalte_date,
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss'
      ]

      for (const format of formats) {
        const parsedDate = this.$time(date, format, true)
        if (parsedDate.isValid()) {
          return parsedDate.format('YYYY-MM-DD')
        }
      }

      if (typeof date === 'string') {
        return date.split('.').reverse().join('-')
      }

      return null
    },

    formatDateForPicker(date) {
      if (!date) {
        return ''
      }

      const formats = [
        'YYYY-MM-DD',
        'YYYY-MM-DD HH:mm:ss',
        this.userSetting.company__tempalte_date
      ]

      for (const format of formats) {
        const parsedDate = this.$time(date, format, true)
        if (parsedDate.isValid()) {
          return parsedDate.format(this.userSetting.company__tempalte_date)
        }
      }

      const parsedFallback = this.$time(date)
      return parsedFallback.isValid()
        ? parsedFallback.format(this.userSetting.company__tempalte_date)
        : ''
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value
      if (
        data.name == 'vehicle_lighthouses__change_after_days' ||
        data.name == 'vehicle_lighthouses__sim'
      ) {
        this.lighhouseListForSend.find(
          (x) => x.id == data.vehicle_lighthouses__id
        )[data.name] = data.value
      }
      if (this.$refs[data.name]) {
        this.$refs[data.name].classList.remove('input-error')
      }
    },
    getData() {
      Promise.all([
        ObjectsService.getAll({ url: `/${this.currentOpenedId}/osago` })
          .then((data) => {
            Object.assign(this.dataForModal, data.data.data.rows[0])
            this.dataTimeSelect.vehicle_osago__policy_to = data.data.data
              .rows[0].vehicle_osago__policy_to
              ? this.normalizeDateForApi(data.data.data.rows[0].vehicle_osago__policy_to)
              : ''

            this.dataTimeSelect.vehicle_osago__policy_from = data.data.data
              .rows[0].vehicle_osago__policy_from
              ? this.normalizeDateForApi(data.data.data.rows[0].vehicle_osago__policy_from)
              : ''
            this.remoteAndAddedFileOsago = data.data.data.rows[0].vehicle_osago__file
          })
          .catch((err) => { }),
        ObjectsService.getAll({ url: `/${this.currentOpenedId}/kasko` })
          .then((data) => {
            this.remoteAndAddedFileKasko = data.data.data.rows[0].vehicle_kasko__file
            Object.assign(this.dataForModal, data.data.data.rows[0])
            this.dataTimeSelect.vehicle_kasko__policy_to = data.data.data
              .rows[0].vehicle_kasko__policy_to
              ? this.normalizeDateForApi(data.data.data.rows[0].vehicle_kasko__policy_to)
              : ''
            this.dataTimeSelect.vehicle_kasko__policy_from = data.data.data
              .rows[0].vehicle_kasko__policy_from
              ? this.normalizeDateForApi(data.data.data.rows[0].vehicle_kasko__policy_from)
              : ''
          })
          .catch((err) => { }),
        GeneralService.get(
          `/trackers?where=[{"field":"gps__vehicle_id", "value":${this.currentOpenedId}}]`
        )
          .then((data) => {
            Object.assign(this.dataForModal, data.data.data.rows[0])
          })
          .catch((err) => { }),
        ObjectsService.getAll({ url: `/${this.currentOpenedId}` })
          .then((data) => {
            // this.dataForModal.vehicles__is_active_fines =
            //   data.data.data.rows[0].vehicles__is_active_fines

            Object.assign(this.dataForModal, data.data.data.rows[0])
          })
          .catch((err) => { }),
        ObjectsService.getAll({ url: `/${this.currentOpenedId}/lighthouses` })
          .then((data) => {
            Object.assign(this.dataForModal, data.data.data.rows[0])
            data.data.data.rows.forEach((element) => {
              let assingDate = this.formatDateForPicker(
                element.vehicle_lighthouses__added_at
              )
              // vehicle_lighthouses__added_at
              this.lighhouseList.push({
                ...element,
                ...{ vehicle_lighthouses__added_at: assingDate }
              })
              this.lighhouseListForSend.push({
                id: element.vehicle_lighthouses__id
              })
            })
          })
          .catch((err) => { }),

        // settingGlobalData
        GeneralService.get('/crm/settings')
          .then((data) => {
            this.settingGlobalData = data.data.data
          })
          .catch((err) => { })
      ]).then(() => {
        this.$emit('loadingModal', false)
        this.loadingState = false

        this.loadGallery = true
      })
    },

    ...mapActions('transportVehiclesModule', ['getHealth', 'getTitle'])
  },

  created() {
    console.log('!!!!!!!!!!!!!!!!!', this.dataForModal);
    this.$emit('loadingModal', true)
    this.getHealth(this.currentOpenedId)
    this.getTitle(this.currentOpenedId)
    this.getData()
  },
  computed: {
    ...mapState('translationModule', ['dataLang']),
    ...mapGetters('transportVehiclesModule', ['numPages']),
    ...mapState('userSettingModule', ['userSetting'])
  }
}
</script>

<style lang="scss" scoped>
.text-black {
  color: black !important;
}

.py-12 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.rounded-8 {
  border-radius: 8px;
}

.w-18 {
  width: 18px;
}

.h-18 {
  height: 18px;
}

.button-custom {
  height: 29px;
  background: linear-gradient(180deg,
      rgba(93, 92, 92, 0.2) 19.38%,
      rgba(215, 215, 215, 0.18) 100%),
    #fff;
  border-color: #ededed;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1),
    0px 1px 1px 0px rgba(0, 0, 0, 0.09), 0px 2px 1px 0px rgba(0, 0, 0, 0.05),
    0px 4px 2px 0px rgba(0, 0, 0, 0.01), 0px 7px 2px 0px rgba(0, 0, 0, 0);
}

.checkbox-custom {
  height: 0;
  width: 0;
  padding: 0;
  margin: 0;
  border: 0 !important;
  outline: 0 !important;
  position: absolute;
  visibility: hidden;
}

.checkbox-custom:checked+span {
  visibility: visible !important;
}
</style>
